import { Box, Card, Chip, Grid, Typography } from "@mui/material";
import { Controller, useWatch } from "react-hook-form";
import BaseTextField from "../../common/base-text-field/base-text-field";
import SingleDatePicker from "../../common/single-date-picker/single-date-picker";
import AutoCompleteComponent from "../../common/base-select/autocomplete-component.js";

export function PassengerFormFields({ control, index, isFirst }) {
    const seatNumber = useWatch({ control, name: `passengers.${index}.seatNumber` });

    const genderOptions = [
        { id: "1", name: "آقا", english_name: "Male" },
        { id: "2", name: "زن", english_name: "Female" },
    ];

    return (
        <Card variant="outlined" sx={{ p: { xs: 2, sm: 3 }, borderRadius: 3, mb: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                {seatNumber && (
                    <Chip label={`صندلی ${seatNumber}`} size="small" color="primary" />
                )}
                <Typography variant="subtitle2" fontWeight="bold">
                    {isFirst ? "مسافر 1 (سرپرست)" : `مسافر ${index + 1}`}
                </Typography>
            </Box>

            <Grid container spacing={4}>
                <Grid item xs={12} sm={6}>
                    <Controller
                        name={`passengers.${index}.first_name`}
                        control={control}
                        rules={{ required: "نام الزامی است" }}
                        render={({ field, fieldState }) => (
                            <BaseTextField
                                label="نام"
                                fullWidth
                                size="medium"
                                radius="10px"
                                value={field.value}
                                setValue={field.onChange}
                                inputRef={field.ref}
                                error={fieldState.error?.message}
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Controller
                        name={`passengers.${index}.last_name`}
                        control={control}
                        rules={{ required: "نام خانوادگی الزامی است" }}
                        render={({ field, fieldState }) => (
                            <BaseTextField
                                label="نام خانوادگی"
                                fullWidth
                                size="medium"
                                radius="10px"
                                value={field.value}
                                setValue={field.onChange}
                                inputRef={field.ref}
                                error={fieldState.error?.message}
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <AutoCompleteComponent
                        control={control}
                        name={`passengers.${index}.gender`}
                        label="جنسیت"
                        type="other"
                        options={genderOptions}
                        register={{ required: "جنسیت الزامی است" }}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Controller
                        name={`passengers.${index}.national_code`}
                        control={control}
                        rules={{
                            required: "کد ملی الزامی است",
                            pattern: { value: /^\d{10}$/, message: "کد ملی باید ۱۰ رقم باشد" },
                        }}
                        render={({ field, fieldState }) => (
                            <BaseTextField
                                label="کد ملی"
                                fullWidth
                                size="medium"
                                radius="10px"
                                value={field.value}
                                setValue={field.onChange}
                                inputRef={field.ref}
                                error={fieldState.error?.message}
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Controller
                        name={`passengers.${index}.birthdate`}
                        control={control}
                        rules={{ required: "تاریخ تولد الزامی است" }}
                        render={({ field, fieldState }) => (
                            <SingleDatePicker
                                {...field}
                                label="تاریخ تولد"
                                errors={fieldState.error?.message}
                                size="medium"
                                handleChange={field.onChange}
                                maxDate={new Date()}
                                control={control}
                                isPersianCalendar={true}
                                register={`passengers.${index}.birthdate`}
                            />
                        )}
                    />
                </Grid>

                {isFirst && (
                    <Grid item xs={12} sm={6}>
                        <Controller
                            name={`passengers.${index}.phone_number`}
                            control={control}
                            rules={{
                                required: "شماره همراه الزامی است",
                                pattern: { value: /^09\d{9}$/, message: "شماره همراه معتبر نیست" },
                            }}
                            render={({ field, fieldState }) => (
                                <BaseTextField
                                    label="شماره همراه (سرپرست)"
                                    fullWidth
                                    size="medium"
                                    radius="10px"
                                    value={field.value}
                                    setValue={field.onChange}
                                    inputRef={field.ref}
                                    error={fieldState.error?.message}
                                />
                            )}
                        />
                    </Grid>
                )}
            </Grid>
        </Card>
    );
}
